import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import toast from 'react-hot-toast';
import { useSearchParams } from 'react-router-dom';
import Button from '~/components/Button';
import SelectIcon from '~/icons/SelectIcon';
import SelectTickIcon from '~/icons/SelectTickIcon';
import { useDispatch, useSelector } from '~/store';
import { submitFormData } from '~/store/slices/formSlice/asyncThunks';
import { selectIsSubmitLoading } from '~/store/slices/formSlice/selectors';

function getTemplatePath(templateId: string): string {
  switch (templateId) {
    case 'inv1':
      return '/media/images/examples/inv1.png';

    case 'inv2':
      return '/media/images/examples/inv2.png';

    case 'inv3':
      return '/media/images/examples/inv3.png';

    case 'inv4':
      return '/media/images/examples/inv4.png';

    case 'inv5':
      return '/media/images/examples/inv5.png';

    case 'inv6':
      return '/media/images/examples/inv6.png';

    case 'inv7':
      return '/media/images/examples/inv7.png';

    default:
      return '/media/images/examples/inv1.png';
  }
}

const Wrapper = styled.div`
  margin-bottom: 24px;
  .select-icon {
    margin-right: 10px;
  }
`;

const TemplateWrapper = styled.div`
  margin-bottom: 48px;
  cursor: pointer;

  .select-tick {
    bottom: -5px;
    right: -12px;
    background: var(--white);
    border-radius: 50%;
  }

  > img {
    border: 1px solid #141414;
    border-radius: 4px;
    width: 188px;
    height: 266px;
    min-width: 188px;
    min-height: 266px;
    max-width: 188px;
    max-height: 266px;
  }
`;

interface ITemplateSelectionProps {
  templateId: string;
}

const TemplateSelection = ({ templateId }: ITemplateSelectionProps) => {
  const isSubmitLoading = useSelector(selectIsSubmitLoading);
  const [, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (isSubmitLoading) {
      return;
    }

    const hasError = document.querySelectorAll('.error-field').length > 0;
    if (hasError) {
      toast.error('Please fill all required fields');
      return;
    }
    const result = await dispatch(submitFormData() as any);
    if (!result.error) {
      setSearchParams(prev => {
        prev.set('preview', 'true');
        return prev;
      });
    }
  };

  const templatePath = getTemplatePath(templateId);
  return (
    <Wrapper className="full-width v-center">
      <TemplateWrapper className="pos-r" onClick={handleSubmit}>
        <img src={templatePath} alt="template-preview" />
        <SelectTickIcon className="pos-a select-tick" />
      </TemplateWrapper>

      <Button
        variant="secondary"
        onClick={handleSubmit}
        className="center full-width"
        disabled={isSubmitLoading}
      >
        {isSubmitLoading ? (
          <LoadingOutlined />
        ) : (
          <>
            <SelectIcon className="select-icon" />
            <span>Change Template</span>
          </>
        )}
      </Button>
    </Wrapper>
  );
};

export default TemplateSelection;
